import React, { useState, useEffect } from "react"
import { EmailIcon, EmailShareButton } from "react-share"
import TextField from "../TextField"
import Button from "../Button"
import PropTypes from "prop-types"
import { Mutation } from "react-apollo"
import gql from "graphql-tag"
import "./style.scss"

const findOrCreateShortenedURL = gql`
  mutation findOrCreateShortenedURL($slug: String!) {
    findOrCreateShortenedURL(slug: $slug) {
      id
      slug
    }
  }
`

const ShareEmail = (props) => {
  const [url, setUrl] = useState("")

  useEffect(() => {
    getHref()
  }, [props.slug])

  const getHref = () => {
    let href = ""
    if (props.slug) {
      props.mutate({ variables: { slug: props.slug } }).then((res) => {
        let { id } = res.data.findOrCreateShortenedURL
        if (id) {
          href = new URL("url/" + id, window.location.origin).href
          setUrl(href)
        }
      })
    }
  }

  const copyLink = () => {
    let input = document.createElement("input")
    input.value = url
    document.body.appendChild(input)
    input.select()
    document.execCommand("copy")
    document.body.removeChild(input)
  }

  return (
    <div className="share-email" style={{ textAlign: "center" }}>
      <EmailShareButton
        style={{ display: "inline-block" }}
        title="Favorite Share"
        subject="Check this Favorite"
        url={url}
      >
        <EmailIcon
          round={true}
          logoFillColor="#4f758f"
          iconBgStyle={{ fill: "#efefef" }}
        />
      </EmailShareButton>
      <p>Email</p>
      <br />
      <div className="share-inputs-container">
        {url && (
          <TextField
            value={url}
            disabled={true}
            fullWidth={true}
            classes={["share-input"]}
            dataCy="short-url"
          />
        )}
        <Button
          action={() => copyLink()}
          text={"Copy"}
          classes={["share-copy-button"]}
        />
      </div>
    </div>
  )
}

const ShareEmailWithData = (props) => {
  return (
    <Mutation
      mutation={findOrCreateShortenedURL}
      variables={{ slug: props.slug }}
    >
      {(mutate) => {
        return <ShareEmail slug={props.slug} mutate={mutate} />
      }}
    </Mutation>
  )
}

export default ShareEmailWithData

ShareEmail.propTypes = {
  slug: PropTypes.string.isRequired,
}
